import { Model } from '..'
import Enhancer from '../Enhancer'
import store from '@/modules/store'
import { Query } from '@/modules/plugins/query'

class Meal extends Model {
    constructor(json, ...args) {
        super(...args)
        this.apiBase = 'meals'
        this._model = json
        this._calculation = {}
        return new Proxy(this, Enhancer)
    }

    getMealOption(id) {
        return `/${this.apiRoot}/${this.apiVersion}/meal-options/${id}`
    }

    getMealOptionGroup(id) {
        return `/${this.apiRoot}/${this.apiVersion}/meal-option-groups/${id}`
    }
    fetch(id) {
        return super.fetch(id, Query.getCanteenParams(store.getters['active/canteen']))
    }
}
export { Meal }
